import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import type FavoritesListingsIndex from "@travily/types/pages/FavoritesListingsIndex";
import { useFavoritesTabs } from "@/hooks/use-favorites-tabs";
import { usePageFavorites } from "@/hooks/use-search-favorites";
import { PageFrame } from "@/layouts/page-frame";
import { FavoritesFrame } from "@/pages/favorites/components/FavoritesFrame";
import { MarketplaceFavorites } from "./index.view";

const FavoritesIndexPage = ({ products, services }: FavoritesListingsIndex) => {
  const { getFavorited, onFavoriteToggle } = usePageFavorites();
  const tabs = useFavoritesTabs();

  return (
    <PageFrame>
      <Head title={t("web.favorites.index.meta_title")} />
      <FavoritesFrame currentTab="marketplace" tabs={tabs} title={t("web.favorites.index.title")}>
        <MarketplaceFavorites
          empty={{
            description: t("web.favorites.index.empty.marketplace.description"),
            title: t("web.favorites.index.empty.marketplace.title"),
          }}
          getFavorited={getFavorited}
          onFavoriteToggle={onFavoriteToggle}
          products={products}
          services={services}
        />
      </FavoritesFrame>
    </PageFrame>
  );
};

export default FavoritesIndexPage;
